export default "__VITE_ASSET__1283a7ab__"